import { GridPosition } from 'types/grid';

export const CELL_HEIGHT = '70px';
export const CELL_WIDTH = '50px';

export type GridCellOnClick = (pos: GridPosition) => void;
